import React from 'react'
import { Form } from 'semantic-ui-react'

export default class BankAccNameField extends React.PureComponent {
  render() {
    const { value, onChange, required } = this.props

    return (
      <Form.Input
        fluid
        label="ABA Account Name"
        placeholder="eg. Tony Stark"
        required={required}
        onChange={e => onChange('aba_account_name', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/bankAccountNameField.js